"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileMimeType = exports.getNameMimeType = void 0;
const tslib_1 = require("tslib");
const mime_1 = tslib_1.__importDefault(require("mime"));
const fileTypes = {
    image: [
        "jpg",
        "jpeg",
        "jpe",
        "heif",
        "heic",
        "png",
        "webp",
        "jxr",
        "jif",
        "jfif",
        "jfi",
        "jp2",
        "j2k",
        "jpf",
        "jpx",
        "jpm",
    ],
    video: ["webm", "mkv", "mov", "qt", "wmv", "mp4", "m4v", "mpg", "mpeg", "mpv", "avi"],
    audio: ["mp3", "aac", "ogg", "m4a"],
};
function getNameMimeType(name) {
    let type = mime_1.default.getType(name) || "";
    if (type === "") {
        const match = ("." + name).match(/(\.[^/.]+)$/);
        const extension = (match && match[0].slice(1)) || "";
        if (fileTypes.video.includes(extension))
            type = "video/mp4";
        else if (fileTypes.image.includes(extension))
            type = "image/jpeg";
        else if (fileTypes.audio.includes(extension))
            type = "audio/mp3";
        else
            type = "application/octet-stream";
    }
    return type;
}
exports.getNameMimeType = getNameMimeType;
function getFileMimeType(file) {
    return file.type || getNameMimeType(file.name);
}
exports.getFileMimeType = getFileMimeType;
//# sourceMappingURL=FileHelpers.js.map